module.exports = __webpack_public_path__ + "static/media/step-backward.e7620820.svg";